import { useBooleanFlagValue } from '@openfeature/react-sdk';

/**
 * Break-glass kill switch for the first-template-creation quality attestation.
 * OFF (default): the gate is live. ON: the dialog never opens and creation
 * proceeds ungated. A mandated risk control, not an experiment — the flag only
 * exists so the gate can be pulled without a deploy if it wrongly blocks saves.
 */
export const useIsTemplateQualityGateKilled = () => {
  return useBooleanFlagValue('op-scribe-disable-template-quality-gate', false);
};
